import { store } from "../store";
import { setAuthToken, setIsLoggedIn } from "../store/slices/authState";
import { setUserData } from "../store/slices/userState";
import { clearToken, clearUserId, saveUserType } from "./asyncStoreManager";
import { string } from "./string";
import asyncStorageKeys from "./asyncStorageKeys";
import { setCartCount, setWhishlistCount } from "../store/slices/countState";
import { BASE_URL } from "./configConstants";
import { setWhishlist } from "../store/slices/whishlistState";
import NavigationService from "../utils/navigationService";
// import { appApiHandler } from "../api/appApiHandler";

export function emailValidator(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function passwordValidator(password) {
  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return passwordRegex.test(password);
}

export const handleNumberInputWithoutDecimal = (text) => {
  let sanitizedText = text?.replace(/[^0-9]/g, "");
  return sanitizedText;
};

export function handleBlanckSpaceInput(text) {
  let sanitizedText = text?.replace(/\s/g, "");
  return sanitizedText;
}

export function handleUpperCaseNoSpace(text) {
  let sanitizedText = text?.replace(/\s/g, "").toUpperCase();
  return sanitizedText;
}

export function getInitials(name) {
  if (!name) return "";
  return name.trim()[0].toUpperCase();
}

export const clearStates = async () => {
  try {
    // const fcmToken = NotificationService.getFCMToken();
    // const reqData = {
    //   token:fcmToken,
    //   user_id:store.getState().userState.userData?._id,
    // }
    // const response = await appApiHandler.logOut(reqData);
    await clearToken();
    await clearUserId();
    await saveUserType("retailer");
    store.dispatch(setUserData(null));
    store.dispatch(setIsLoggedIn(false));
    store.dispatch(setAuthToken(""));
    store.dispatch(setCartCount(0));
    store.dispatch(setWhishlistCount(0));
    store.dispatch(setWhishlist([]));

    // Navigate to login using navigation service
    // NavigationService.resetToLogin();

    return true;
  } catch (error) {
    console.error("Error clearing states:", error);
    return false;
  }
};

export const getErrorMessage = (msg) => {
  const messsage =
    typeof msg === "string" ? msg : string.error.failed_due_to_internal_error;
  return messsage;
};

export const getPrice = (item) => {
  try {
    const userType =
      window.localStorage.getItem(asyncStorageKeys.USER_TYPE) || null;
    const value =
      userType === "wholeseller"
        ? parseInt(item?.wholesale_price)
        : parseInt(item?.retail_price);
    return Number.isNaN(value) ? 0 : value;
  } catch (e) {
    const fallback = parseInt(item?.retail_price);
    return Number.isNaN(fallback) ? 0 : fallback;
  }
};

export const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  return `${BASE_URL}${imagePath}?t=${Date.now()}`;
};


export const getOptimizedUrl = (path, height, width) => {
   return `${BASE_URL}${path}`;
  // const queryParams = [`path=${encodeURIComponent(path)}`];
  // if (width !== undefined && width !== null && width !== "") {
  //   queryParams.push(`width=${width}`);
  // }
  // if (height !== undefined && height !== null && height !== "") {
  //   queryParams.push(`height=${height}`);
  // }
  // const optimizedUrl = `${BASE_URL}optimized-image?${queryParams.join("&")}`;
  // return `${optimizedUrl}?t=${Date.now()}`;
};
